import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../hooks/useAxios";
import Button from "../../../shared/Button";
import FaqAccordion from "./FaqAccordion";
import FaqSearch from "./FaqSearch";

const FaqList = () => {
  const [faqList, setfaqList] = useState([])
  const apiGetFAQ = useFetch({
    method: "get",
    url: "api/faqs",
    noHeader: true,
    trigger: true,
   
    argFunc: res => {
      setfaqList(res.data)
    }
  });
  console.log(faqList)
  const navigate = useNavigate()
  return (
    <div className="FaqList">
      <Button onClick={()=>navigate("/admin/Add-Faq")} varient="primary">
        اضافه کردن پرسش جدید
      </Button>
      <div className="center-column">
        <h2>لیست سوالات متداول</h2>
        <p className="FaqList--des my-[30px]">
          علاوه بر صرفه جویی در پاسخ دادن به بسیاری از تماس‌های قبل از خرید و
          پشتیبانی های لازم، صفحات FAQ همچنین می توانند یک راه عالی برای معرفی
          محصولات و برند شما نیز باشند.
        </p>
        <FaqSearch/>
      </div>
    {faqList.length > 0 &&  <FaqAccordion info={faqList}/>}
    </div>
  );
};

export default FaqList;
